import FlexBox from '../FlexBox'

import type { ReactNode } from 'react'
import type { FlexBoxProps } from '../FlexBox/FlexBox'

interface Props extends FlexBoxProps {
  children: ReactNode
}

const FlexRow = ({ children, ...props }: Props) => (
  <FlexBox row {...props}>
    {children}
  </FlexBox>
)

export default FlexRow
